import styled, { css } from 'styled-components'

const ACTIVE_DRAG_STYLE = ({ theme, $isDragActive }) =>
  $isDragActive
    ? css`
        background: ${theme.colors.primary}22;
        padding: ${theme.spacing.md}rem;
        border-radius: ${theme.borderRadius.md}rem;
        border: 3px dashed ${theme.colors.primary};
      `
    : css``

const baseTargetStyle = css`
  flex: 1;
  box-sizing: border-box;
`

const increasedTargetSizeStyle = css`
  padding: ${({ theme }) => theme.spacing.lg}rem 0;
  margin: -${({ theme }) => theme.spacing.lg}rem 0;

  ${ACTIVE_DRAG_STYLE}
`

const DROPZONE_STYLE = css<{ $isDragActive: boolean }>`
  width: 100%;
  margin: 0;
  border: 1px dashed
    ${({ theme, $isDragActive }) =>
      $isDragActive ? theme.colors.primary : `${theme.colors.iconGray}88`};
  border-radius: ${({ theme }) => theme.borderRadius.md}rem;
  padding: ${({ theme }) => theme.spacing.xl}rem;
  background: ${({ theme, $isDragActive }) =>
    $isDragActive ? `${theme.colors.primary}10` : theme.colors.neutralWhite};
`

const SECTION_STYLE = css<{
  $isDragActive: boolean
  $compactSectionEmpty?: boolean
}>`
  width: 100%;
  margin: ${({ $compactSectionEmpty }) => ($compactSectionEmpty ? '-0.6rem' : '0')};
  padding: ${({ theme, $compactSectionEmpty }) =>
    $compactSectionEmpty
      ? `${theme.spacing.md}rem ${theme.spacing.sm}rem`
      : `${theme.spacing.xl}rem ${theme.spacing.lg}rem`};
  border: 1px solid transparent;
  background: ${({ theme, $isDragActive }) =>
    $isDragActive ? `${theme.colors.primary}10` : 'transparent'};
`

export const StyledEmptyAttachmentSelector = styled.div<{
  $isDragActive: boolean
  $appearance?: 'default' | 'dropzone' | 'section'
  $compactSectionEmpty?: boolean
}>`
  ${baseTargetStyle};
  ${({ $appearance }) =>
    $appearance === 'dropzone'
      ? DROPZONE_STYLE
      : $appearance === 'section'
      ? SECTION_STYLE
      : increasedTargetSizeStyle}

  display: flex;
  align-items: center;
  justify-content: ${({ $appearance, $compactSectionEmpty }) =>
    $appearance === 'section' && $compactSectionEmpty
      ? 'flex-start'
      : $appearance === 'dropzone' || $appearance === 'section'
      ? 'center'
      : 'flex-start'};
  color: ${({ theme }) => theme.colors.metalGray};

  .add-more {
    font-size: ${({ theme }) => theme.fontSize.sm}rem;
    color: ${({ theme }) => theme.colors.metalGray};
    text-align: ${({ $appearance, $compactSectionEmpty }) =>
      $appearance === 'section' && $compactSectionEmpty
        ? 'left'
        : $appearance === 'dropzone' || $appearance === 'section'
        ? 'center'
        : 'left'};
  }
`

export const StyledAttachmentSelector = styled.div<{
  $isDragActive: boolean
  $appearance?: 'default' | 'dropzone' | 'section'
  $compact?: boolean
}>`
  ${baseTargetStyle};
  ${({ $appearance, $compact }) =>
    $appearance === 'dropzone'
      ? DROPZONE_STYLE
      : $appearance === 'section'
      ? SECTION_STYLE
      : $compact
      ? null
      : increasedTargetSizeStyle}

  .add-more {
    color: ${({ theme }) => theme.colors.metalGray};
    font-size: ${({ theme }) => theme.fontSize.sm}rem;
    text-align: ${({ $appearance }) =>
      $appearance === 'dropzone' || $appearance === 'section' ? 'center' : 'left'};
    margin-top: ${({ theme }) => theme.spacing.sm}rem;
  }
`
